export default __webpack_public_path__ + "static/media/img-utility-right.a5f4d5d9.png";